module.exports = __webpack_public_path__ + "static/maskable_icon-ed499377bf4acd3b54ed8182bb1dc84b.png";